import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import packageJson from '../../package.json';

import { AppSupportedLanguage } from './enums';

export const initI18n = () => {
  // Use package version for cache busting
  const version = packageJson.version;

  return i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
      nonExplicitSupportedLngs: true,
      supportedLngs: Object.values(AppSupportedLanguage),
      fallbackLng: 'en',
      detection: {
        order: ['navigator'],
      },
      backend: {
        loadPath: '/i18n/{{lng}}/translation.json',
        // Add version parameter for cache busting of translation files
        queryStringParams: { v: version },
      },
    });
};
